import { Typography } from '@gympass/tai-chi/typography';
import styled from '@mui/material/styles/styled';
import type { CSSObject } from '@mui/material/styles';

import type { ThemeProps } from 'typings/styles';

export const PositionContentDiv = styled('div')(() => ({
  minHeight: '100dvh',
  paddingBlockStart: '15vh',
}));

const maxIllustrationWidth = '15rem';
const illustrationWidth = `min(100%, ${maxIllustrationWidth})`;

export const Main = styled('main')(({ theme }: ThemeProps) => ({
  paddingBlockEnd: theme.spacing(8),
  paddingInline: theme.spacing(6),
  display: 'grid',
  gridTemplateColumns: 'auto',
  placeContent: 'center',
  placeItems: 'center',
  rowGap: theme.spacing(7),

  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: `${illustrationWidth} auto`,
    columnGap: theme.spacing(9),
    placeItems: 'center end',
  },
}));

export const Illustration = styled('figure')(() => ({
  display: 'flex',
  justifyContent: 'center',

  '> svg': { width: 'auto', height: 'auto', maxWidth: illustrationWidth },
}));

export const Article = styled('article')(({ theme }: ThemeProps) => ({
  placeSelf: 'center',
  textAlign: 'center',
  display: 'inline-grid',
  rowGap: theme.spacing(2),

  [theme.breakpoints.up('md')]: {
    placeSelf: 'center',
    textAlign: 'start',
  },

  '> *:last-of-type': {
    marginTop: theme.spacing(3),
    width: 'fit-content',
    placeSelf: 'center',
    [theme.breakpoints.up('md')]: {
      placeSelf: 'start',
    },
  },
}));

export const Title = styled(Typography)(({ theme }) => {
  return {
    color: theme.palette.text.primary,
    [theme.breakpoints.down('md')]: {
      placeSelf: 'center',
    },
  } satisfies CSSObject;
});

export const SubTitle = styled(Typography)(({ theme }) => {
  return {
    color: theme.palette.text.secondary,
    [theme.breakpoints.down('md')]: {
      placeSelf: 'center',
    },
  } satisfies CSSObject;
});
